import { Heading, HStack, Link, Image } from "@chakra-ui/react";
import * as React from "react";
import { Link as ReachLink } from "react-router-dom";

export const Logo = () => {
  return (
    <>
      <HStack>
        <Link
          as={ReachLink}
          to="/"
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          <img
            src="/FooterLogo.svg"
            width="50%"
            className="d-inline-block align-top"
            alt="Good Regime"
          />
        </Link>
        {/* <a href="/">
          <Image
            width="40"
            height="20"
            objectFit="contain"
            src="Logo.svg"
            alt="Good Regime"
          />
        </a> */}
        {/* <Heading fontSize={"xl"}>GoodRegime</Heading> */}
      </HStack>
    </>
  );
};
